/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function CRCreated({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><rect width={16} height={16} fill="#348DF8" rx={8} /><path fill="#fff" fillRule="evenodd" d="M13.106 5.483a1.76 1.76 0 0 1-1.354 1.712v.318c0 2.466-2 4.466-4.466 4.466h-.318A1.76 1.76 0 1 1 4.85 9.861V4.129a.406.406 0 0 1 .812 0v5.732c.645.152 1.154.66 1.306 1.306h.318a3.654 3.654 0 0 0 3.654-3.654v-.318a1.76 1.76 0 1 1 2.166-1.712" clipRule="evenodd" /></svg>;
}
;